// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"61c394ce","513":"0619b309","703":"e87620f6","763":"79c028af"}[chunkId] + ".chunk.js";
};